<template>
    <div class="main">
        <Container>
            <slot></slot>
        </Container>
    </div>
</template>

<script lang="ts" setup></script>

<style scoped lang="less">
.main {
    width: 100%;
    background-color: #f6f7fd;
    min-height: calc(100vh);
}
</style>
